<template>
  <div class="organizations">
    <div class="container">
      <div class="organ" style="margin-top: 0 !important;">
        <el-link icon="el-icon-s-grid" :underline="false">主要部门</el-link>
       <!-- <p>Departments</p> -->
        <p class="notes">共同打造国内领先、国际超前的现代化信息企业</p>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"  v-for="(item,index) in data" :key="index">
            <div @click="toDeps(item.id)">
              <el-card shadow="hover">
                <i :class="item.icon"  class="classification"></i>
                <h3>{{item.name}}</h3>
                <p>{{item.information}}</p>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        show2: true,
        data:[]
      }
    },
    mounted() {
      this.axios.get(this.$http +"/api/index/getDepartments", {
          params: {}
        })
        .then((res) => {
          this.data = res.data.data;
        })
        .catch((err) => {})
    },
    methods: {
      toDeps: function(mallCode) {
        this.$router.push({
          path: '/dep',
          query: {
            type: mallCode,
          }
        })
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Organizations.vue